import TextField from "@mui/material/TextField";

const StyledTextField = (props) => {
  return (
    <TextField
      {...props}
      sx={{
        margin: "normal",
        required: true,
        fullWidth: true,
        autoComplete: "off",
        "& .MuiOutlinedInput-root": {
          "&.Mui-focused fieldset": {
            borderColor: "#0070f2",
          },
        },
        "& .MuiInputLabel-outlined.Mui-focused": {
          color: "#0070f2",
        },
      }}
    />
  );
};

export default StyledTextField;
